export default __webpack_public_path__ + "static/media/brand_security.415ec705.svg";